import { useAppDispatch } from 'hooks';
import React, { useEffect } from 'react';
import { requestsActions } from 'utils/store/slice';
import { RequestsTable, RequestPopUp } from './components';

export const RequestsScreen = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(requestsActions.getPaginatedRequests());
  }, [dispatch]);

  return (
    <>
      <RequestsTable />
      <RequestPopUp />
    </>
  );
};
